module.exports = __webpack_public_path__ + "fonts/Catamaran-Regular.2de7e6f5.woff";